import CarouselWithVideo from "Components/CarouselWithVideo/carouselWithVideo";

const videosWithTitles = [
  {
    title: "Get Your Personalized College Recommendations In 5 Steps!",
    videoSrc: "/videos/carouselVideo.mp4",
    thumbnailSrc: "/images/thumbnail1.jpg",
  },
  {
    title: "Get Your Personalized College Recommendations In 5 Steps!",
    videoSrc: "/videos/carouselVideo.mp4",
    thumbnailSrc: "/images/thumbnail1.jpg",
  },
];

export const LandingPageCarouselWithVideo = () => {
  return <CarouselWithVideo videosWithTitles={videosWithTitles} />;
};
